import { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { HTML_ELEMENT_THEME_PROVIDER_ID } from '../../../constants/html'

function GretaAIChatPortal({ children }) {
  const [container] = useState(() => document.createElement('div'))

  useLayoutEffect(() => {
    const host = document.getElementById(HTML_ELEMENT_THEME_PROVIDER_ID)

    host.appendChild(container)

    return () => {
      container.remove()
    }
  }, [container])

  return createPortal(children, container)
}

export default GretaAIChatPortal
